import type { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core';
import type { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

import {
  BLOOD_PRESSURE,
  HEART_RATE,
  RESPIRATION,
  HR_VARIABILITY,
  STRESS_INDEX,
  WAIST_HEIGHT_RATIO,
  WAIST_HIP_RATIO,
  CHEST_CM,
  WAIST_CM,
  HIPS_CM,
  THIGH_CM,
  BODY_FAT_PERCENTAGE,
  BODY_WEIGHT,
  OXYGEN_SATURATION,
} from './fhir';

// SCAN APP LINKS
// TODO Replace with real URL once published
export const SCAN_APP_STORE_LINK =
  'https://apps.apple.com/us/app/vitall-scan/id6503484328';
// TODO Replace with real URL once published
export const SCAN_GOOGLE_PLAY_LINK =
  'https://play.google.com/store/apps/details?id=com.vitallhealth.scan';

export const SCAN_ANDROID_INTENT_LINK_PREFIX =
  'intent://scan#Intent;scheme=com.vitallhealth.scan;package=com.vitallhealth.scan';
export const SCAN_ANDROID_INTENT_LINK_SUFFIX = ';end';
// 'intent://scan/#Intent;scheme=zxing;package=com.google.zxing.client.android;end',
export const SCAN_ANDROID_INTENT_LINK =
  'intent://scan#Intent;scheme=com.vitallhealth.scan;package=com.vitallhealth.scan;end';
export const SCAN_IOS_URL_SCHEME = 'com.vitallhealth.scan://scan';

export const FACE_SCAN_OBS_ORDER = [
  BLOOD_PRESSURE,
  HEART_RATE,
  OXYGEN_SATURATION,
  RESPIRATION,
  HR_VARIABILITY,
  // IRREGULAR_HR,
  // CARDIAC_WORKLOAD,
  STRESS_INDEX,
];
export const BODY_SCAN_OBS_ORDER = [
  WAIST_HEIGHT_RATIO,
  WAIST_HIP_RATIO,
  CHEST_CM,
  WAIST_CM,
  HIPS_CM,
  THIGH_CM,
  BODY_FAT_PERCENTAGE,
  BODY_WEIGHT,
];

enum CoughScanDisease {
  ASTHMA = 'asthma',
  BRONCHIECTASIS = 'bronchiectasis',
  CHRONIC_OBSTRUCTIVE_PULMONARY_DISEASE = 'copd',
  COVID = 'covid',
  INTERSTITIAL_LUNG_DISEASE = 'ild',
  PNEUMONIA = 'pneumonia',
  TUBERCULOSIS = 'tuberculosis',
}

enum CoughScanField {
  Text = 'text',
  Description = 'description',
}

export interface StackedIconProps extends Omit<FontAwesomeIconProps, 'icon'> {
  name: IconName;
  type?: IconPrefix;
}

const SCAN_BATCH_SIZE = 10;
const COUGH_LOW_DISEASE_LIKELIHOOD = 40;
const COUGH_MID_DISEASE_LIKELIHOOD = 80;
const COUGH_HIGH_DISEASE_LIKELIHOOD = 100;

export {
  COUGH_LOW_DISEASE_LIKELIHOOD,
  COUGH_MID_DISEASE_LIKELIHOOD,
  COUGH_HIGH_DISEASE_LIKELIHOOD,
  CoughScanDisease,
  CoughScanField,
  SCAN_BATCH_SIZE,
};
